import React from "react";
import { Container } from "react-bootstrap";

// Default styles that can be reused across components
export const defaultOuterStyle: React.CSSProperties = {
  backgroundColor: "#e9ecef",
  minHeight: "100vh",
};

export const defaultInnerStyle: React.CSSProperties = {
  backgroundColor: "#fff",
  padding: "25px",
  borderRadius: "10px",
  boxShadow: "0 0 15px rgba(0,0,0,0.1)",
};

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  outerStyle?: React.CSSProperties;
  innerStyle?: React.CSSProperties;
  fluid?: boolean;
  useFragment?: boolean;
}

const PageContainer: React.FC<PageContainerProps> = ({
  children,
  className = "",
  outerStyle,
  innerStyle,
  fluid = true,
  useFragment = true,
}) => {
  const mergedOuterStyle: React.CSSProperties = {
    ...defaultOuterStyle,
    ...outerStyle,
  };

  const mergedInnerStyle: React.CSSProperties = {
    ...defaultInnerStyle,
    ...innerStyle,
  };

  const content = (
    <div
      className={`page-content px-4 ${className}`}
      style={mergedOuterStyle}
    >
      <Container fluid={fluid} style={mergedInnerStyle}>
        {children}
      </Container>
    </div>
  );

  if (useFragment) {
    return <>{content}</>;
  }

  return content;
};

export default PageContainer;

